// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

const RESTART_SIGN_IN_KEY = "riddle.auth.restartSignIn";

export function hasAttemptedRestartSignIn(): boolean {
  try {
    return window.sessionStorage.getItem(RESTART_SIGN_IN_KEY) !== null;
  } catch {
    return true;
  }
}

export function markRestartSignInAttempt(): void {
  try {
    window.sessionStorage.setItem(RESTART_SIGN_IN_KEY, "1");
  } catch {
  }
}

export function clearRestartSignInAttempt(): void {
  try {
    window.sessionStorage.removeItem(RESTART_SIGN_IN_KEY);
  } catch {
  }
}
